// NPM Imports
import React, { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import { UpgradeBadge, UpgradePopUp } from "../../../../commonComponents";

export default function AddAnotherRuleUpgrade(props) {
  // Local State Declaration(hooks)
  const [showPopUp, togglePopUp] = useState(false);
  return (
    <Fragment>
      <div
        className="tempworkflow-addrule-btn"
        role="button"
        tabIndex="0"
        onClick={() => togglePopUp(true)}
        onKeyDown={() => togglePopUp(true)}>
        <i>
          <FontAwesomeIcon icon={["far", "plus-circle"]} />
        </i>
        Add another rule <UpgradeBadge />
      </div>
      {showPopUp && (
        <UpgradePopUp
          featureName={props.featureName}
          onClose={() => togglePopUp(false)}
        />
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Template/TempWorkFlow/AddAnotherRule/AddAnotherRuleUpgrade.js